/*
 * Copyright (c) 2023. Collabro Limited
 */
import React, { ReactNode } from "react";
import { Paper } from "@mui/material";

const BookingCard: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Paper
      component="div"
      elevation={3}
      sx={{
        display: "flex",
        width: "40%",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 5,
        padding: 2,
      }}
    >
      {children}
    </Paper>
  );
};

export default BookingCard;
